import { mixins, styled } from '@bob/library'

export const Wrapper = styled.div`
  padding-top: 5px;

  border-radius: 20px;
  position: relative;
`

export const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  ${mixins.margin.top(5)}
  ${mixins.margin.bottom(20)}
`

export const IconItem = styled.div`
  display: flex;
  align-items: center;
  ${mixins.margin(0, 10)}
  ${mixins.typography.paragraphSmall}
  & svg {
    ${mixins.margin.left(5)}
  }
`

export const RetiredInfo = styled.p`
  text-align: center;
  ${mixins.margin.top(5)};
  ${mixins.margin.bottom(15)};
  ${mixins.typography.paragraphSmall};
`

export const SuitableStudent = styled.div`
  ${mixins.typography.paragraphSmall}
  text-align: center;
  ${mixins.margin.bottom(20)}
`

export const GrantText = styled.div`
  ${mixins.typography.paragraphSmall}
  ${mixins.margin.top(30)}
  ${mixins.margin.bottom(10)}
`

export const GrantLink = styled.a`
  ${mixins.typography.noColor.paragraphSmall};
  color: ${mixins.colors.corporateBlue};
  text-decoration: underline;
  ${mixins.margin.left(5)};
  &:hover {
    text-decoration: none;
  }
`
